import { createFeatureSelector } from '@ngrx/store';
import { Brand, Category, Prodotto } from '../../../models/Prodotto';
import { HttpStatus } from '../../../models/http-status';

export interface FeatureState {
    list: Prodotto[],
    categories: Category[],
    brands: Brand[],
    brandsDeleteError: string,
    errors: HttpStatus
}

export const featureSelect = createFeatureSelector<FeatureState>('prodotti');
